import React, { useState } from "react";
import "./EmailDesign.css";

export default function EmailDesign() {
  const [formData, setFormData] = useState({
    headerImage: "",
    footerText: "",
    footerTextColor: "#000000",
    footerBgColor: "#B0ADC5",
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData({
      ...formData,
      [name]: files ? files[0] : value,
    });
  };

  const handleUpdate = () => {
    console.log("Updated Email Design:", formData);
  };

  return (
    <div className="email-page">
      {/* Header */}
      <div className="email-header">
        <h2>Email Page Design</h2>
        <div className="breadcrumb">
          <a href="/">Home</a> / Email Page Design
        </div>
      </div>

      <div className="card">
        <h4>Update Email Design</h4>

        {/* Header Image + Footer Colors */}
        <div className="form-row-inline">
          <div className="form-group">
            <label>
              Email Header Image <span>(Best size 800px × 400px)</span>
            </label>
            <input
              type="file"
              name="headerImage"
              onChange={handleChange}
              accept="image/*"
            />
          </div>

          <div className="form-group">
            <label>Footer Text Color</label>
            <div className="color-input">
              <input
                type="color"
                name="footerTextColor"
                value={formData.footerTextColor}
                onChange={handleChange}
              />
              <input
                type="text"
                value={formData.footerTextColor}
                onChange={(e) =>
                  setFormData({ ...formData, footerTextColor: e.target.value })
                }
              />
            </div>
          </div>

          <div className="form-group">
            <label>Footer Background Color</label>
            <div className="color-input">
              <input
                type="color"
                name="footerBgColor"
                value={formData.footerBgColor}
                onChange={handleChange}
              />
              <input
                type="text"
                value={formData.footerBgColor}
                onChange={(e) =>
                  setFormData({ ...formData, footerBgColor: e.target.value })
                }
              />
            </div>
          </div>
        </div>

        {/* Footer Text */}
        <div className="form-row">
          <label>
            Footer Text <span>(Footer Text for email)</span>
          </label>
          <textarea
            name="footerText"
            rows="4"
            value={formData.footerText}
            onChange={handleChange}
            placeholder="Write footer text..."
          ></textarea>
        </div>

        {/* Update Button */}
        <div className="form-actions">
          <button className="btn-update" onClick={handleUpdate}>
            Update
          </button>
        </div>
      </div>

      {/* Email Preview */}
      <div className="card preview">
        <h4>Email Preview</h4>
        <div className="preview-box">
          {formData.headerImage && (
            <img
              src={URL.createObjectURL(formData.headerImage)}
              alt="Header Preview"
              className="preview-img"
            />
          )}
          <div className="preview-content">
            <p>Email content will appear here...</p>
          </div>
          <div
            className="preview-footer"
            style={{
              backgroundColor: formData.footerBgColor,
              color: formData.footerTextColor,
            }}
          >
            {formData.footerText || "Footer content here..."}
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="page-footer">
        <p>
          Copyright © 2025 <span>Ample Markets</span>. All rights reserved.
        </p>
        <p className="version">Version 2.0</p>
      </footer>
    </div>
  );
}

